export default __webpack_public_path__ + "static/media/8823.8edb6306.svg";